const API_URL = 'https://mobile.telkomuniversity.ac.id/';
// const API_URL = 'https://myteluapimanagement.azure-api.net/core/';

export default API_URL
    
